import _ListCache_default from "./_ListCache.js";

//#region ../../node_modules/lodash-es/_stackClear.js
/**
* Removes all key-value entries from the stack.
*
* @private
* @name clear
* @memberOf Stack
*/
function stackClear() {
	this.__data__ = new _ListCache_default();
	this.size = 0;
}
var _stackClear_default = stackClear;

//#endregion
export { _stackClear_default as default };
//# sourceMappingURL=_stackClear.js.map